import React from "react";
import ExcalidrawViewer from "../../components/ExcalidrawViewer";

const AustraliaOilReservesByState: React.FC = () => (
  <ExcalidrawViewer
    filePath="/excalidraw/australia-oil-reserves-by-state.excalidraw"
    title="Australia's Oil & Fuel Reserves By State"
    subtitle="Refineries, terminals, ports & who's really safe -- state-by-state breakdown with Queensland deep dive"
  />
);

export default AustraliaOilReservesByState;
